import api from 'api/apiInstance';

export function clientMessagesInteractionReportApi(path: string) {
  return {
    path,
    DELETE: () => api.delete(path),
  };
}
